import React from 'react';
import { Layout } from '../components/common';

const PutawayManagementDemo = () => {
  return (
    <Layout activeNav="putaway" onNavChange={() => {}}>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Putaway Management</h1>
        <p className="text-gray-600">Manage inventory putaway operations.</p>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <p className="text-gray-600 text-lg">Putaway Management Content Coming Soon</p>
      </div>
    </Layout>
  );
};

export default PutawayManagementDemo;
